import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProofBar } from './components/ProofBar';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen w-full flex flex-col" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProofBar data-id="element-3" />
      <PainSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <ProductSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <ForWhomSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <FinalCta data-id="element-11" />
      <Footer data-id="element-12" />
      <RecentPurchaseToast data-id="element-13" />
    </div>;
}